
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Adaugă-l pe Ecranul Principal pentru o experiență extinsă și acces facil.`,
's224cbcec014ef6b5': `Apasă Partajare în bara de navigare`,
's37a9e8aec5713460': `Mai mult`,
's386eca8362ff6155': `Apasă Mai mult dacă nu există pictograma Partajare`,
's4e1e10a6ca408245': `Atinge „Adaugă pe ecranul principal”`,
's6196153c4b0c1ea0': `Instalați`,
's633502f7cff4f847': `Deschide meniul browserului tău`,
's681e399d63311fba': `Afișează galeria`,
's7f0591f08e318eda': `Apasă Mai mult în meniul Partajare`,
's8114bd55cae5a22b': `Apasă pe „Adaugă în Dock”`,
's922329d6f6213590': `Adaugă în Dock`,
's9af56bf005b49c74': `Derulează în jos până la „Adaugă pe ecranul principal”`,
'sa5ef80b4bb9b39f8': `Mai puțin`,
'sba52286c21552a4e': `Instalează-l pe dispozitivul tău pentru o experiență completă și acces facil.`,
'sc16e00a7a8b2fde2': `Înapoi`,
'scdaf4bbff76674c8': `Adaugă pe Ecranul Principal`,
'se0e473adfda8066c': `Deschide în browserul principal`,
'se740f75b95a51807': `Adaugă-l în Dock pentru o experiență extinsă și acces facil.`,
'sfea652f6580ff086': `Acest site are funcționalități de aplicație.`,
    };
  